import { render, staticRenderFns } from "./GainLossDetail.vue?vue&type=template&id=3c405769&"
import script from "./GainLossDetail.vue?vue&type=script&lang=js&"
export * from "./GainLossDetail.vue?vue&type=script&lang=js&"
import style0 from "./GainLossDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports